import bidello from '../bidello'
import gsap, { Power4 } from 'gsap'
import stars from '../webgl/stars/stars'
import scroll from '../animations/scroll/locomotiveScroll'
import Home from '../routes/home'
import menu from '../menu'
import world from '../webgl/world/world'

export const homeTransition = {
  name: 'home',

  to: {
    namespace: 'home',
  },

  once({ next }) {
    scroll.stop()

    bidello.on('loaderEnd', () => {
      bidello.trigger({ name: 'enterHome' })
      Home.animating = true
      Home.animations[0].play()
      stars.enter()
    })
  },

  enter({ next, current }) {
    console.log('enter')

    bidello.trigger({ name: 'enterHome' })
    Home.animating = true
    Home.animations[0].play()
    stars.enter()

    gsap.to(next.container, {
      autoAlpha: 1,
      duration: 1,
    })

    // scroll.stop()
    // Home.animating = true
    // Home.animations[0].play()
    // stars.enter()
  },

  leave({ next, current }) {
    console.log('leave home')
    if (menu.isOpen) {
      menu.menuLeave()
    }

    gsap.set(next.container, { autoAlpha: 0 })

    return gsap.to(current.container, {
      opacity: 0,
      duration: 1.2,
      onComplete: () => {
        scroll.scrollTo({ target: 0, options: { duration: 0, disableLerp: true } })
      }
    })
  }
}
